import { useContext } from "react";
import { UserSettingsContext } from "@/contexts/UserSettingsContextTypes";

export function useUserSettingsContext() {
  const context = useContext(UserSettingsContext);
  if (context === undefined) {
    throw new Error(
      "useUserSettingsContext must be used within a UserSettingsProvider"
    );
  }
  return context;
}
